module.exports = __webpack_public_path__ + "./docs/img/vox-logo-white.933070dcf6c58ad4420a361a9312eca0.svg";